import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const HabitationalPolicyUpdates = Loadable(
  lazy(() =>
    import("./HabitationalPolicyUpdates").then(({ HabitationalPolicyUpdates }) => ({
      default: HabitationalPolicyUpdates,
    }))
  )
);

export const HabitationalPolicyUpdatesRoutes = [
  {
    path: `/habitational-policy/:customerId/updates/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <HabitationalPolicyUpdates />
      </AuthorizedRoute>
    ),
  },
]